import moment from 'moment';
import CodeMirror from 'codemirror';
import { createDateReplacementNode } from '../markers/utils';
import StupiddDatePickerStore from '../components/stupid-date-picker/store';



// 时间相关的函数替换
export function replaceDateLikeFunction(
  editor: CodeMirror.Editor,
  token: CodeMirror.Token,
  datePickerStore: StupiddDatePickerStore
) {
  if (!token || !token.type) { return 0; }
  const types = token.type.split(' ');
  if (types.includes('declaration') && (
    types.includes('Date') ||
    types.includes('Time') ||
    types.includes('DateTime')
  )) {
    const line = token.state.line;
    const functionName = types.includes('Date') ? 'Date' : types.includes('DateTime') ? 'DateTime' : 'Time';

    const startPos = { line, ch: token.start };
    const endPos = { line, ch: token.end };
    const dateString = token.string.match(/\(['"](.*)['"]\)/)![1];

    const replacement = dateString; // types.includes('DateTime') ? moment(dateString).format() : dateString;

    // 预览模式下点击日期不需要弹出选择控件
    const replacementNodeClickListener = datePickerStore.isPreviewMode ? undefined :
      generateDatePicker(editor, datePickerStore, startPos, endPos, dateString, functionName as any);

    editor.getDoc().markText(startPos, endPos, {
      replacedWith: createDateReplacementNode(
        replacement,
        'cm-' + functionName.toLowerCase(),
        replacementNodeClickListener
      )
    });
    return 1;

  }



  return 0;
}


function generateDatePicker(
  editor: CodeMirror.Editor,
  datePickerStore: StupiddDatePickerStore,
  startPos: CodeMirror.Position,
  endPos: CodeMirror.Position,
  currentDateString: string,
  mode: 'Time' | 'Date' | 'DateTime'
) {
  return (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const isDateLikeMode = mode === 'Date' || mode === 'DateTime';
    const pickerStore = datePickerStore as StupiddDatePickerStore;


    const momentDate = isDateLikeMode ?
      moment(currentDateString) :
      moment(currentDateString, 'HH:mm:ss');

    const { top, left, width, height } = (event.target as HTMLSpanElement).getBoundingClientRect();

    const position = {
      left: left + width / 4,
      top: top + height + 10
    };

    pickerStore.openPicker({
      value: momentDate,
      position,
      config: {
        showTime: mode === 'DateTime',
        isTimePicker: !isDateLikeMode,
        onChange: (date, dateString) => {
          const replacementString = mode === 'DateTime' ?
            `DateTime("${date.format()}")` :
            (mode === 'Date' ? `Date("${dateString}")` : `Time("${dateString}")`);

          editor.getDoc().replaceRange(replacementString, startPos, endPos);
        }
      }
    });
  };
}
